import { render, staticRenderFns } from "./NewSidebar.vue?vue&type=template&id=3f64b342&scoped=true"
import script from "./NewSidebar.vue?vue&type=script&lang=js"
export * from "./NewSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewSidebar.vue?vue&type=style&index=0&id=3f64b342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64b342",
  null
  
)

export default component.exports